import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { string, bool, func } from 'prop-types'
import withSizes from 'react-sizes'
import MdAssignment from 'react-icons/lib/md/assignment'
import FaMap from 'react-icons/lib/fa/map'
import { P, Option } from '../styles/option'
import {
  handleToggleList,
  toggleSearchContentFooter,
} from '../../../../../store/Actions/UiActions'

class ToggleMapListButton extends PureComponent {
  handleToggleList = () => {
    this.props.toggleList(!this.props.listShow)
    if (this.props.isSmallScreen) {
      this.props.toggleSearchContent(false)
    }
  }

  renderButton = () =>
    this.props.activeButton === 'map' ? (
      <Fragment>
        <FaMap color={this.props.theme} />
        <P theme={this.props.theme}>Map</P>
      </Fragment>
    ) : (
      <Fragment>
        <MdAssignment color={this.props.theme} />
        <P theme={this.props.theme}>List</P>
      </Fragment>
    )

  render() {
    return (
      <Option onClick={() => this.handleToggleList()} title="Toggle List view.">
        {this.renderButton()}
      </Option>
    )
  }
}

const ListOrMap = ({
  theme,
  listShow,
  toggleList,
  isSmallScreen,
  toggleSearchContent,
}) => (
  <ToggleMapListButton
    theme={theme}
    toggleList={toggleList}
    listShow={listShow}
    isSmallScreen={isSmallScreen}
    toggleSearchContent={toggleSearchContent}
    activeButton={listShow ? 'map' : 'list'}
  />
)

ToggleMapListButton.propTypes = {
  theme: string.isRequired,
  listShow: bool.isRequired,
  toggleList: func.isRequired,
  activeButton: string.isRequired,
}

ListOrMap.propTypes = {
  theme: string.isRequired,
  listShow: bool.isRequired,
  toggleList: func.isRequired,
}

const mapStateToProps = ({ spi, ui }) => ({
  theme: spi.theme,
  listShow: ui.listShow,
})

const mapDispatchToProps = dispatch => ({
  toggleList: value => dispatch(handleToggleList(value)),
  toggleSearchContent: value => dispatch(toggleSearchContentFooter(value)),
})

const mapSizesToProps = ({ width }) => ({ isSmallScreen: width < 768 })

export default withSizes(mapSizesToProps)(
  connect(mapStateToProps, mapDispatchToProps)(ListOrMap)
)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/ListButton/index.jsx